<template>
    <ul class="cursus-steps">
        <template v-for="(step, i) in visibleSteps">
            <Step
                :step="step"
                :done="isDone(step)"
                :active="isActive(step)"
                :index="i + 1"
            />
        </template>
    </ul>
</template>

<script>
    import Step from "./Step";

    export default {
        components: {
            Step
        },
        props: {
            steps: Array,
            orderStep: String,
        },
        computed: {
            visibleSteps() {
                return this.steps.filter(step => !step.hidden);
            },
        },
        methods: {
            isActive(step) {
                return step.route.name === this.$route.name;
            },
            isDone(step) {
                const index = this.steps.findIndex(s => s.value === step.value);
                const orderStepIndex = this.steps.findIndex(s => s.value === this.orderStep);
                if(orderStepIndex === -1) {
                    return index <= this.steps.findIndex(step => this.isActive(step));
                }
                return index <= orderStepIndex;
            },
            async layout() {
                await this.$nextTick();
                if(this.$el.scrollWidth > this.$el.offsetWidth) {
                    const activeStep = this.$el.querySelector('.cursus-step--active');
                    if(activeStep && activeStep.offsetLeft + activeStep.offsetWidth > this.$el.offsetWidth) {
                        this.$el.scrollLeft = activeStep.offsetLeft;
                    }
                }
            },
        },
        mounted() {
            this.layout();
        },
        updated() {
            this.layout();
        }
    }
</script>
